import { makeAutoObservable, flow } from 'mobx'
import AsyncStorage from '@react-native-community/async-storage'
import api from '../api'
import _ from 'lodash'

class NotificationStore {
    notifications = []
    notificationCount = 0

    constructor() {
        makeAutoObservable(this)
    }

    listNotifications = flow(function* (skip) {
        try {
            const token = yield AsyncStorage.getItem('token')
            const response = yield api.listNotifications(token, limit = 20, skip)
            const { notifications, count } = response.data
            this.notifications = notifications
            this.notificationCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listMoreNotifications = flow(function* (skip) {
        try {
            const token = yield AsyncStorage.getItem('token')
            const response = yield api.listNotifications(token, limit = 20, skip)
            const { notifications, count } = response.data
            this.notifications = _.union(this.notifications, notifications)
            this.notificationCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    updateNotificationRead = flow(function* (notificationId) {
        try {
            const token = yield AsyncStorage.getItem('token')
            const response = yield api.updateNotificationRead(token, notificationId)
            const index = this.notifications.findIndex((f) => { return f._id == notificationId })
            if (index !== -1) {
                this.notifications[index] = response.data
            }
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    count = flow(function* () {
        try {
            const token = yield AsyncStorage.getItem('token')
            const response = yield api.notificationCount(token)
            return Promise.resolve(response.data)
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })
}

export default new NotificationStore()